"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductType = exports.AppSwitcher = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _Apps = _interopRequireDefault(require("@material-ui/icons/Apps"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _List = _interopRequireDefault(require("../List"));

var _SearchInput = _interopRequireDefault(require("../SearchInput"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Alert = _interopRequireDefault(require("../Alert"));

var _ExpansionPanel = _interopRequireDefault(require("../ExpansionPanel"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _OrganizationHelper = require("../Utilities/OrganizationHelper");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    popoverContainer: {
      width: "400px",
      maxWidth: "100%",
      padding: theme.spacing(2, 0, 0)
    },
    titleWrapper: {
      padding: theme.spacing(0, 2, 1)
    },
    searchWrapper: {
      width: 0,
      padding: theme.spacing(0, 2)
    },
    accordionWrapper: {
      background: theme.palette.grey[100],
      maxHeight: "calc(100vh - 250px)",
      // let try to not have this container out of control
      margin: theme.spacing(2, 0, 0),
      overflowY: "auto",
      overflowX: "hidden",
      borderTop: "1px solid " + theme.palette.divider
    },
    list: {
      "& .prmbl-listItem.prmbl-button": {
        textTransform: "none",
        letterSpacing: "normal"
      }
    },
    rightIcon: {
      marginLeft: theme.spacing(2),
      display: "flex"
    },
    icon: {
      marginRight: theme.spacing(2),
      width: 40
    },
    block: {
      borderTop: "1px solid ".concat(theme.palette.divider),
      textAlign: "right"
    },
    popoverPaper: {
      boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 10%), 0px 1px 10px 0px rgb(0 0 0 / 12%)"
    },
    featuredButton: {
      justifyContent: "end"
    },
    alert: {
      borderRadius: 0
    },
    alertFooter: {
      margin: theme.spacing(2, 0, 0)
    },
    groupSection: {
      width: "100%",
      "& .prmbl-expansionPanel-details": {
        background: theme.palette.grey[100],
        padding: 0,
        display: "block",
        overflowY: "auto",
        overflowX: "hidden"
      }
    },
    separator: {
      borderTop: "1px solid " + theme.palette.divider
    },
    groupSectionMaxHeight: {
      "& .prmbl-expansionPanel-details": {
        maxHeight: "calc(100vh - 250px)" // let try to not have this container out of control

      }
    },
    buttonActive: {
      background: theme.palette.grey[100] + "!important",
      margin: 0 + "!important" // We want to override the default moving effect

    },
    chevron: {
      color: theme.palette.grey[500]
    },
    resetOpacity: {
      opacity: "1!important"
    },
    sticky: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "inherit"
    }
  };
});
var ProductType = {
  0: "CivicPlus",
  1: "CivicEngage Central",
  2: "CivicReady",
  3: "CivicHR",
  4: "Zapier",
  5: "CivicRec",
  6: "Content Management",
  7: "CivicPay",
  8: "CivicEngage Evolve",
  9: "CivicClerk",
  10: "CivicPlus Notifications",
  11: "CivicPlus Connect",
  12: "CivicPlus Forms",
  13: "CivicPlus Bids",
  14: "CivicPlus Integrations",
  15: "SeeClickFix"
};
exports.ProductType = ProductType;

var AppSwitcher = function AppSwitcher(props) {
  var currentOrg = props.currentOrg;
  var classes = useStyles(props);

  var getVisibleApps = function getVisibleApps(org) {
    var tempApps = [];
    org.applications.forEach(function (app) {
      if (app.visibility === "Visible") tempApps.push(app);
    });
    org.applications = tempApps;
    return org;
  };

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = _react.default.useState(""),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      searchValue = _React$useState4[0],
      setSearchValue = _React$useState4[1];

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      appItems = _useState2[0],
      setAppItems = _useState2[1];

  var _React$useState5 = _react.default.useState(0),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      active = _React$useState6[0],
      setActive = _React$useState6[1];

  var _React$useState7 = _react.default.useState(true),
      _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
      isDisabled = _React$useState8[0],
      setDisabled = _React$useState8[1];

  (0, _react.useEffect)(function () {
    if (currentOrg !== undefined) {
      setAppItems([getVisibleApps(currentOrg)]);
      setDisabled(false);
    } else {
      setDisabled(true);
      setAppItems([]);
    }
  }, [currentOrg]);
  (0, _react.useEffect)(function () {
    // Clear the search when the Popover is opened
    if (anchorEl) {
      clearSearch();
    }
  }, [anchorEl]);

  var handleSearch = function handleSearch(event) {
    setSearchValue(event.target.value);
  };

  var clearSearch = function clearSearch() {
    setSearchValue("");
  };

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleCloseMenu = function handleCloseMenu() {
    setAnchorEl(null);
  }; // Magic to do the search filtering


  var applicationsFiltered = [];
  appItems.forEach(function (org) {
    var hasItems = org.applications.filter(function (app) {
      return (// TODO: Enhance this logic to look also for additional attributes from the Org. like product name, tag, site names, etc.
        app.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    }).sort(function (a, b) {
      // Sort alphabetically
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });

    if (hasItems.length > 0) {
      applicationsFiltered.push({
        name: (0, _OrganizationHelper.formatOrgName)(org, org.name),
        content: /*#__PURE__*/_react.default.createElement(_List.default, {
          id: "prmbl-appSwitcher-locations",
          className: classes.list,
          "aria-label": "Applications",
          subheaders: [{
            listItems: hasItems.map(function (item) {
              return {
                itemIcon: /*#__PURE__*/_react.default.createElement(_Logo.default, {
                  product: ProductType[item.productType || 0],
                  circle: true,
                  className: classes.icon
                }),
                itemText: {
                  primary: item.name,
                  secondary: item.productType ? ProductType[item.productType] : undefined
                },
                button: true,
                href: item.productUri,
                openInNewWindow: true,
                onClick: handleCloseMenu
              };
            })
          }]
        })
      });
    }
  });

  var notSearchResult = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    "aria-live": "assertive",
    role: "alert",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    id: "message-warning",
    className: classes.alert,
    title: "No search results",
    severity: "warning"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "We couldn't find any applications in your current organization that match the search.", /*#__PURE__*/_react.default.createElement("div", {
    className: classes.alertFooter
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outlined",
    size: "small",
    color: "inherit",
    onClick: clearSearch
  }, "Clear search"))))));

  var notResult = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    "aria-live": "assertive",
    role: "alert",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    id: "message-warning",
    className: classes.alert,
    title: "No results",
    severity: "warning"
  }, "We couldn't find any applications in your current organization. Please contact an administrator if you believe this is an error.")));

  var popoverContent = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 0,
    className: classes.popoverContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    className: classes.titleWrapper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6"
  }, "Switch Applications")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    className: classes.searchWrapper
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    placeholder: "Search for application name...",
    autoFocus: true,
    fullWidth: true,
    variant: "compact",
    margin: false,
    value: searchValue,
    onChange: handleSearch,
    searchOnChange: true
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    className: classes.accordionWrapper
  }, applicationsFiltered.length > 0 ? applicationsFiltered.map(function (item, key) {
    var _classNames;

    return /*#__PURE__*/_react.default.createElement(_ExpansionPanel.default, {
      id: "accordion-".concat(key),
      key: key,
      square: true,
      disabled: Boolean(searchValue) || applicationsFiltered.length === 1 // If we are searching or there is only 1 org. then we disable the collapse for the panel
      ,
      expanded: searchValue ? true : Boolean(active === key) // If we are searching, then we force the panel to be expanded
      ,
      onChange: function onChange() {
        return setActive(key);
      },
      className: (0, _classnames.default)(classes.groupSection, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.groupSectionMaxHeight, applicationsFiltered.length > 1), (0, _defineProperty2.default)(_classNames, classes.separator, key > 0), _classNames)),
      classes: {
        expanded: classes.buttonActive
      },
      summaryProps: {
        classes: {
          disabled: classes.resetOpacity,
          root: classes.sticky
        }
      },
      expandIcon: applicationsFiltered.length > 1 ? /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
        className: classes.chevron
      }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
      expandSummary: /*#__PURE__*/_react.default.createElement(_Typography.default, {
        className: "group-title"
      }, item.name),
      expandDetails: item.content
    });
  }) : searchValue ? notSearchResult : notResult));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleClick,
    type: "icon",
    title: "Switch Applications",
    disabled: isDisabled
  }, /*#__PURE__*/_react.default.createElement(_Apps.default, null)), /*#__PURE__*/_react.default.createElement(_Popover.default, {
    disableScrollLock: true,
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleCloseMenu,
    id: "app-switcher-menu",
    classes: {
      paper: classes.popoverPaper
    }
  }, popoverContent));
};

exports.AppSwitcher = AppSwitcher;
var _default = AppSwitcher;
exports.default = _default;